import { Address } from "@certn/cascadia/patterns/address-form/types";
import { isAddressErrors } from "@certn/cascadia/patterns/address-form/utils";
import { useField, useFormikContext } from "formik";

import { AddressForm } from "../patterns/address-form/AddressForm";

interface AddressFormFormikFieldProps {
  name: string;
  testID?: string;
  isDisabled?: boolean;
  postalCodeRequired?: boolean;
  streetAddressRequired?: boolean;
  unitNumberRequired?: boolean;
  localityRequired?: boolean;
  administrativeDivision1Required?: boolean;
  administrativeDivision2Required?: boolean;
  showStreetAddress?: boolean;
  showUnitNumber?: boolean;
  countryRequired?: boolean;
}

export function AddressFormFormikField(props: AddressFormFormikFieldProps) {
  const {
    name,
    testID = "address-form-field",
    isDisabled,
    postalCodeRequired,
    streetAddressRequired,
    unitNumberRequired,
    localityRequired,
    administrativeDivision1Required,
    administrativeDivision2Required,
    showStreetAddress,
    showUnitNumber,
    countryRequired,
  } = props;
  const [field, meta, helpers] = useField<Address & { address_line_1: string }>(
    name
  );

  const { submitCount } = useFormikContext();

  return (
    <AddressForm
      isDisabled={isDisabled}
      postalCodeRequired={postalCodeRequired}
      streetAddressRequired={streetAddressRequired}
      unitNumberRequired={unitNumberRequired}
      localityRequired={localityRequired}
      administrativeDivision1Required={administrativeDivision1Required}
      administrativeDivision2Required={administrativeDivision2Required}
      showStreetAddress={showStreetAddress}
      showUnitNumber={showUnitNumber}
      countryRequired={countryRequired}
      value={{
        ...field.value,
        street_address:
          field.value?.street_address ?? field.value?.address_line_1 ?? "",
      }}
      onChange={(value) => {
        helpers.setValue({
          ...value,
          address_line_1: value.street_address ?? "",
        });
      }}
      errors={isAddressErrors(meta.error) ? meta.error : undefined}
      isSubmitted={submitCount > 0}
      testID={testID}
    />
  );
}
